export const login = [
    {
        'field': 'username',
        'label': "Username",
        'rules': ['string', 'required'],
    },
    {
        'field': 'password',
        'label': 'Password',
        'rules': ['string', 'required'],
    },
];

export const signup = [
    {
        'field': 'username',
        'label': "Username",
        'rules': ['string', 'no_symbol', 'required'],
    },
    {
        'field': 'password',
        'label': 'Password ',
        'rules': ['string', 'required', 'min|6'],
    },
    {
        'field': 'confirm_password',
        'label': 'Confirm Password',
        'rules': ['string', 'required', 'match|password|Password'],
    },
    {
        'field': 'full_name',
        'label': 'Full Name',
        'rules': ['string', 'only_string', 'required'],
    }
];

export const contact_us = [
    {
        'field': 'contact_name',
        'label': "Your Name",
        'rules': ['string', 'no_symbol', 'required']
    }
];